import { render, staticRenderFns } from "./Ownprices.vue?vue&type=template&id=08c5d33a&scoped=true"
import script from "./Ownprices.vue?vue&type=script&lang=js"
export * from "./Ownprices.vue?vue&type=script&lang=js"
import style0 from "./Ownprices.vue?vue&type=style&index=0&id=08c5d33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5d33a",
  null
  
)

export default component.exports